import React from 'react';
import PageTitle from '../../../widgets/PageTitle/PageTitle';
import './YDCAdditional.scss';
import { sanitizedHTML, parseSanitizedHTML } from '../../../utils/Helper';
import { replaceParentStyle } from '../../../utils/UtilsClass';

const YDCAdditional = (props) => {
  const { curLang, data, tabId } = props;

  return (
    <>
      <PageTitle title={data.additional_item_title} />

      <div
        className={'ydc-additional' + tabId}
        dangerouslySetInnerHTML={{
          __html: sanitizedHTML(
            replaceParentStyle(data.additional_item_body, 'ydc-additional' + tabId),
            true,
          ),
        }}
      />
    </>
  );
};

export default YDCAdditional;
